import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Menu, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { MessageFrame } from './MessageFrame';
import { MessageScrollArea } from './MessageScrollArea';
import scrollAreaStyles from './scrollArea.module.scss';
export const GetListSelectMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ListSelectMessage = (param)=>{
    let { content, messageId, onListSelectClick, onSubmitFeedback, onDismissFeedback } = param;
    const { ListSelectMessageTID } = useMemo(()=>GetListSelectMessageTID(messageId), [
        messageId
    ]);
    const disabled = onListSelectClick == null;
    const menuItems = useMemo(()=>content.items.map((item)=>({
                id: item.id,
                testId: ListSelectMessageTID.Item(item.id),
                title: item.title,
                body: item.subtitle,
                disabled,
                bi: {
                    name: 'agent_drafting_list_select_item',
                    data: {
                        item_id: item.id
                    }
                },
                onClick: disabled ? undefined : ()=>onListSelectClick === null || onListSelectClick === void 0 ? void 0 : onListSelectClick(messageId, item.id, item.title)
            })), [
        content.items,
        disabled,
        messageId,
        onListSelectClick,
        ListSelectMessageTID
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(MessageFrame, {
                testId: ListSelectMessageTID.Root(),
                padding: "16px 0 0 0",
                fillHeight: true,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: ListSelectMessageTID.Intro(),
                        className: scrollAreaStyles.framePad,
                        children: content.intro
                    }),
                    content.question !== content.intro && /*#__PURE__*/ _jsx(Typography, {
                        testId: ListSelectMessageTID.Question(),
                        className: scrollAreaStyles.framePad,
                        children: content.question
                    }),
                    /*#__PURE__*/ _jsx(MessageScrollArea, {
                        testId: ListSelectMessageTID.Items(),
                        fullWidth: true,
                        children: /*#__PURE__*/ _jsx(Menu, {
                            items: menuItems,
                            dimensions: {
                                width: '100%'
                            },
                            flat: true
                        })
                    })
                ]
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
